import styled from 'styled-components';

export const HeaderStyled = styled.div`
  padding: ${props => props.theme.size.rap};
  .title {
    text-align: center;
    font-size: ${props => props.theme.font.h3};
    font-weight: bold;
  }
`;
